module.exports = __webpack_public_path__ + "img/industry1.122fcab1.jpg";